/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".main-test[_ngcontent-%COMP%]{font-size:20px;font-weight:700}.not-found-text[_ngcontent-%COMP%]{font-size:15px}\n/*# sourceMappingURL=404.component.css.map*/"];
export { styles as styles };
